import { compositionTypeCodeBaselineMeasureReport, emptyReasonNotStarted } from "../../dictionaries/CodeSystemLookup";

const addElementValuesForBaselineMeasureReportFromComparativeEvidenceReport = (resourceJson) => {
    if (!resourceJson) {
        return null;
    }
    let addElementValues = {
        "type": compositionTypeCodeBaselineMeasureReport,
        "relatesTo": [
            {
                "type": {
                        "coding": [
                            {
                                "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
                                "code": "part-of",
                                "display": "Part Of"
                            }
                        ]
                    },
                "targetReference": {
                    "reference": "Composition/" + resourceJson.id,
                    "type": "Composition",
                    "display": resourceJson.title
                }
            }
        ],
        "section": []
    };
    let populationReference;
    let screenedGroupReference;
    let excludedGroupReference;
    let interventionGroupReference;
    let interventionDescriptionReference;
    let comparatorGroupReference;
    let comparatorDescriptionReference;
    let groupAssignmentReference;
    let baselineMeasuresReferences = [];
    let baselineMeasuresListReferences = [];
    if (Array.isArray(resourceJson.section)) {
        for (const section of resourceJson.section) {
            let sectionCode = section?.code?.coding?.[0]?.code || section?.code?.text;
            if (sectionCode === "population" && section.entry?.[0]) {
                populationReference = section.entry[0];
                if (sectionCode === "screened-group" && section.entry?.[0]) {
                    excludedGroupReference = section.entry[0];
                }
                if (sectionCode === "excluded-group" && section.entry?.[0]) {
                    populationReference = section.entry[0];
                }
            }
            if (sectionCode === "study-sample") {
                if (section.entry?.[0]) {
                    populationReference = section.entry[0];
                } else if (section.section?.[0]?.entry?.[0]) {
                    populationReference = section.section[0].entry[0];
                }
            }
            if (sectionCode === "intervention-group") {
                if (section.entry?.[0]) {
                    interventionGroupReference = section.entry[0];
                }
                if (section.section?.length) {
                    for (const subsection of section.section) {
                        let subsectionCode = subsection?.code?.coding?.[0]?.code || subsection?.code?.text;
                        if (subsectionCode === "intervention-description" && subsection.entry?.[0]) {
                            interventionDescriptionReference = subsection.entry[0];
                        }
                    }
                }
            }
            if (sectionCode === "comparator-group") {
                if (section.entry?.[0]) {
                    comparatorGroupReference = section.entry[0];
                }
                if (section.section?.length) {
                    for (const subsection of section.section) {
                        let subsectionCode = subsection?.code?.coding?.[0]?.code || subsection?.code?.text;
                        if (subsectionCode === "comparator-description" && subsection.entry?.[0]) {
                            comparatorDescriptionReference = subsection.entry[0];
                        }
                        if (subsectionCode === "GroupAssignment" && subsection.entry?.[0]) {
                            groupAssignmentReference = subsection.entry[0];
                        }
                    }
                }
            }
            if (sectionCode === "baseline-measures" && section.entry?.length > 0) {
                for (const entry of section.entry) {
                    if (entry.type === "EvidenceVariable") {
                        baselineMeasuresReferences.push(entry);
                    } else if (entry.type === "List") {
                        baselineMeasuresListReferences.push(entry);
                    }
                }
            }
        }
    }
    if (!groupAssignmentReference && interventionDescriptionReference && comparatorDescriptionReference) {
        addElementValues.contained = [{
            "resourceType": "EvidenceVariable",
            "id": "group-assignment",
            "meta": { "profile": ["http://hl7.org/fhir/uv/ebm/StructureDefinition/group-assignment"] },
            "title": "GroupAssignment: " + interventionDescriptionReference.display + " vs. " + comparatorDescriptionReference.display,
            "status": "active",
            "definition": {
                "concept": {
                    "coding": [{
                        "system": "https://fevir.net/resources/CodeSystem/179423",
                        "code": "defined-in-handling-and-category",
                        "display": "Defined in handling and category elements"
                    }]
                }
            },
            "handling": "dichotomous",
            "category": [
                {
                    "name": interventionDescriptionReference.display,
                    "valueReference": interventionDescriptionReference
                },
                {
                    "name": comparatorDescriptionReference.display,
                    "valueReference": comparatorDescriptionReference
                }
            ]
        }];
        groupAssignmentReference = {
            "reference": "#group-assignment",
            "type": "EvidenceVariable",
            "display": "GroupAssignment: " + interventionDescriptionReference.display + " vs. " + comparatorDescriptionReference.display
        }
    }
    let groupListSection = {
        "title": "Baseline Group List",
        "code": { "text": "BaselineGroupList" },
        "text": {
    "status": "empty",
    "div": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[No data.]</p></div>'
},
        "entry": [],
        "emptyReason": emptyReasonNotStarted
    }
    if (screenedGroupReference) {
        groupListSection.entry.push(screenedGroupReference);
    }
    if (excludedGroupReference) {
        groupListSection.entry.push(excludedGroupReference);
    }
    if (populationReference) {
        groupListSection.entry.push(populationReference);
    }
    if (interventionGroupReference) {
        groupListSection.entry.push(interventionGroupReference);
    } else if (interventionDescriptionReference) {
        groupListSection.entry.push(interventionDescriptionReference);
    }
    if (comparatorGroupReference) {
        groupListSection.entry.push(comparatorGroupReference);
    } else if (comparatorDescriptionReference) {
        groupListSection.entry.push(comparatorDescriptionReference);
    }
    if (groupAssignmentReference) {
        groupListSection.entry.push(groupAssignmentReference);
    }
    if (groupListSection.entry.length > 0) {
        delete groupListSection.emptyReason;
    }
    addElementValues.section.push(groupListSection);
    if (baselineMeasuresReferences.length > 0) {
        for (const outcomeMeasure of baselineMeasuresReferences) {
            if (outcomeMeasure.type === "EvidenceVariable") {
                let resultsEntry = {
                    "title": outcomeMeasure.display,
                    "code": {
                        "coding": [{
                            "system": "https://fevir.net/resources/CodeSystem/179423",
                            "code": "results", "display": "Results"
                        }]
                    },
                    "focus": outcomeMeasure,
                    "text": {
    "status": "empty",
    "div": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[No data.]</p></div>'
},
                    "entry": [],
                    "emptyReason": emptyReasonNotStarted
                };
                addElementValues.section.push(resultsEntry);
            }
        }
    }
    return addElementValues;
};

export default addElementValuesForBaselineMeasureReportFromComparativeEvidenceReport;